import { render, staticRenderFns } from "./myInquiryCart.vue?vue&type=template&id=4c8bc092&scoped=true"
import script from "./myInquiryCart.vue?vue&type=script&lang=js"
export * from "./myInquiryCart.vue?vue&type=script&lang=js"
import style0 from "./myInquiryCart.vue?vue&type=style&index=0&id=4c8bc092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bc092",
  null
  
)

export default component.exports